import { render, staticRenderFns } from "./HelpExamine.vue?vue&type=template&id=063d4773&"
import script from "./HelpExamine.vue?vue&type=script&lang=js&"
export * from "./HelpExamine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports